import { Element } from './serialized-types';
import { evalInContext } from '../utils';

type BotElementType = {new(type: string): BotElement, fromJSON(obj: Element): any};

abstract class BotElement {
    type: string;
    id: string | null = null;
    if: string | null = null;
    public static readonly elementClasses: { [s: string]: BotElementType } = {};

    constructor(type: string) {
        this.type = type;
    }

    static register(typeName: string) {
        return function (elementClass: BotElementType) {
            BotElement.elementClasses[typeName] = elementClass;
        }
    }

    static fromJSON(obj: Element): BotElement | null { return null };

    shouldStop(context: object) {
        return false;
    }

    shouldShow(context: object): boolean {
        if (this.if !== null) {
            return evalInContext(this.if, context) && true;
        }

        return true;
    }
}

export {
    BotElement,
    BotElementType
}
